export default "__VITE_ASSET__DKTursO9__"